// extracted by mini-css-extract-plugin
export default {"container":"Styles-module__container--8d17","text":"Styles-module__text--fff3","action":"Styles-module__action--9e7f","button":"Styles-module__button--c273"};